import { AttentionModal } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

// needed because `handleClick` is recreated on each render and removing event listener would not clean different one than assigned in `useEffect`
let handleClick;

function WarningAlert(props) {
  const { setIsLinkClicked, isLinkClicked, displayModal, title, alertMessage } = props;
  const [showModal, setShowModal] = useState(displayModal);
  const [link, setLink] = useState('');

  const cleanEventListeners = () => {
    document.removeEventListener('click', handleClick, true);
    document.removeEventListener('submit', handleClick, true);
  };

  const confirmHandle = () => {
    setShowModal(false);
    setIsLinkClicked(true);
    cleanEventListeners();
    link.click();
  };

  const closeHandle = () => {
    setShowModal(false);
  };

  useEffect(() => {
    handleClick = (e) => {
      const tag = e.target.tagName.toLowerCase();
      const tags = ['a', 'button', 'span', 'img'];
      const excludeClassList = ['cc-btn', 'cta', 'radio-other-link', 'inputFormatter__selector', 'clickable-label'];

      const excludedElement =
        e.target.closest('.uploader') === null &&
        e.target.closest('#modal-root') === null &&
        e.target.closest('.notification-content') === null;

      const excludedClass = excludeClassList.filter((element) => {
        return e.target.classList.contains(element);
      });

      if (tags.includes(tag) && excludedElement && excludedClass.length === 0) {
        e.stopPropagation();
        e.preventDefault();
        setShowModal(true);
        setLink(e.target);

        return false;
      }

      return true;
    };

    document.addEventListener('click', handleClick, true);
    document.addEventListener('submit', handleClick, true);

    return cleanEventListeners;
  }, [isLinkClicked]);

  return (
    <AttentionModal
      onClose={() => closeHandle()}
      onConfirm={() => confirmHandle()}
      text={alertMessage}
      title={title}
      visible={showModal}
    />
  );
}

WarningAlert.propTypes = {
  setIsLinkClicked: PropTypes.func.isRequired,
  isLinkClicked: PropTypes.bool.isRequired,
  displayModal: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  alertMessage: PropTypes.string.isRequired,
};

export default WarningAlert;
